import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import * as colors from 'commons/styles/colors';

class STOCheckSummaryPageStyleClass extends CommonComponentStyle {
  ChildContentWrapper = styled(this.ContentWrapper)`
    padding-top: 8px;
    overflow: visible;
  `;

  Header = styled.p<{ color?: string }>`
    padding: 8px 0;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    margin-bottom: 0;
    color: ${(props): string => props.color || colors.PRIMARY_GREEN};
  `;

  SubHeader = styled.p`
    padding: 8px 0;
    text-align: center;
    margin-top: 0;
  `;

  ItemContentWrapper = styled(Grid)`
    border: 1px solid #0000001a;
    padding: 8px;
    border-radius: 4px;
  `;

  SubHeaderText = styled.p`
    font-weight: 700;
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  SubHeaderAdditionalText = styled.p`
    font-weight: 400;
    font-size: 12px;
  `;

  STONumberText = styled.span`
    border-radius: 8px;
    font-size: 10px;
    background: ${colors.LIGHT_GRAY};
    color: ${colors.PRIMARY_GRAY};
    padding: 6px;
  `;
}

export const STOCheckSummaryPageStyle = new STOCheckSummaryPageStyleClass();
